import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';

import { LoginService } from '../auth/login/login.service';
import { ClientTableDataService } from '../table/table.service';
import { ForwardFinanceService } from '../../services/forwardfinance.service';

import { Observable, Subscriber } from 'rxjs';
import { tap, map, filter } from 'rxjs/operators';

@Injectable()
export class FarmerFinanceQuoteService{
	private postBody: {};
	private producer: string;
	httpRes: any;
	public quote: any = [];
	public p_payment_date: Date;
	public p_repayment_date = new Date(Date.now() + 30*864e5);
	public quoteResult: any;
	public policyChecked: boolean = false;

	constructor(
		private http: HttpClient,
		private lS: LoginService,
		public tS: ClientTableDataService,
    public fFS: ForwardFinanceService,
		) {}

	 async requestquotation(quote: any, paydate: any) {
  	var payment_date = moment(this.p_payment_date).format('DD-MM-YYYY');
	 	for (var i=0; i<quote.length; i++) {
	 		if (quote[i]['repaydate'].substr(2,1)!='-') {
	 			quote[i]['repaydate'] = moment(quote[i]['repaydate']).format('DD-MM-YYYY');
	 		}
	 	}
	 	this.fFS.getQuote(quote, payment_date, this.lS);
  }

	 async acceptquotation(quote: any, paydate: any) {
  	var payment_date = moment(this.p_payment_date).format('DD-MM-YYYY');
	 	for (var i=0; i<quote.length; i++) {
	 		if (quote[i]['repaydate'].substr(2,1)!='-') {
	 			quote[i]['repaydate'] = moment(quote[i]['repaydate']).format('DD-MM-YYYY');
	 		}
	 	}
	 	return this.fFS.acceptQuote(quote, payment_date, this.lS);
  }

  clearQuote() {
  	this.quoteResult = null;
  	this.tS.fquote = [];
  	this.tS.fquotetotal = {'total': 0, 'max': 0, 'paid': 0, 'request': 0, "id" : []};
  }

	fixDate(field) {
		if (this[field]!==null && this[field]!=='') {
	  	this[field] = moment(this[field]).format('YYYY-MM-DD');
	  }
	}




}